"use strict";
// @flow
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginRequest = exports.msalConfig = exports.getAzureTokens = exports.Session = void 0;
// vendors
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const config_1 = require("./config");
Object.defineProperty(exports, "msalConfig", { enumerable: true, get: function () { return config_1.msalConfig; } });
Object.defineProperty(exports, "loginRequest", { enumerable: true, get: function () { return config_1.loginRequest; } });
const store_1 = require("../../store");
class Session extends web_ui_security_1.AzureSession {
    constructor() {
        super((0, store_1.getDefaultMemoryStore)());
    }
    doRefresh() {
        throw new Error('Error while creating session');
    }
}
exports.Session = Session;
const getAzureTokens = async () => {
    const session = new Session();
    const azureAdInitialized = new web_ui_security_1.AzureAd(session, config_1.msalConfig);
    await azureAdInitialized.login(config_1.loginRequest);
    const data = session.getData();
    return (data && {
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
    });
};
exports.getAzureTokens = getAzureTokens;
//# sourceMappingURL=azureCommons.js.map